import React from 'react';
import { useParams } from 'react-router-dom';
import useFeatureToggleService from 'feature-toggle';
import {
  Button,
  ButtonColor,
  ButtonSize,
  FormTemplate,
  Right,
  SubmitButton,
} from 'ui-builder';
import { useProjectPlanService } from 'nekst-api';
import { PreviousButton } from '../Buttons';
import useAdditionalWorkflowLaunchNavigator from './additionalWorkflowLaunchNavigator';
import AdditionalWorkflowSteps, { AdditionalWorkflowStepId } from './AdditionalWorkflowSteps';
import { useConflictsContext } from './AdditionalWorkflowLaunchWrapper';
import { useProjectContext } from '../../view/ProjectContext';
import RelativeRow from '../../../shared/web/uitheme/form/RelativeRow';
import CurrentTransactionPartiesForm
  from '../CurrentTransactionPartiesForm/CurrentTransactionPartiesForm';
import InformationBox from '../../../shared/web/layout/InformationBox';
import { AddPersonToTransactionForm } from 'features/tasks-forms';

import styles from '../AddTransactionParties.module.scss';

export default function AdditionalWorkflowPartiesPage() {
  const navigator = useAdditionalWorkflowLaunchNavigator();
  const params = useParams();
  const conflictsContext = useConflictsContext();
  const featureToggleService = useFeatureToggleService();
  const isNewFlowEnabled = featureToggleService.isApplyAdditionalWorkflowEnabled();
  const projectPlanService = useProjectPlanService();
  const projectContext = useProjectContext();

  const projectId = parseInt(params.id!, 10);
  const planId = parseInt(params.planId!, 10);

  const sourcePlansCount = projectContext.plan?._sourcePlans?.length ?? 1;
  const applyButtonText = sourcePlansCount > 1 ? 'Apply Workflows' : 'Apply Workflow';

  const submitFunc = async () => {
    await projectPlanService.applyAdditionalProjectPlan(projectId, planId);
    navigator.openProjectPage(true);
  };

  return (
    <>
      <InformationBox
        text="Assign Team Members To Roles with tasks. Add other parties to the transaction."
      />
      <AdditionalWorkflowSteps
        currentStep={AdditionalWorkflowStepId.PARTIES}
        hasConflicts={conflictsContext.hasConflicts}
        hasGroups={projectContext.plan?.hasGroups}
      />
      <div
        style={{
          marginBottom: '4rem',
          overflow: 'hidden',
        }}
      >
        <PreviousButton
          onClick={(isNewFlowEnabled && conflictsContext.hasConflicts)
            ? navigator.openConflictsPage
            : navigator.openAllTasksPage}
        />
        {isNewFlowEnabled ? (
          <Right>
            <FormTemplate
              submitFormFunc={submitFunc}
              initialData={{}}
              buttons={(
                <SubmitButton
                  text={applyButtonText}
                  color={ButtonColor.GREEN}
                  isFilled
                  size={ButtonSize.BIG}
                  testId="apply-workflow-button"
                />
              )}
            />
          </Right>
        ) : (
          <Right>
            <Button
              text="Done"
              size={ButtonSize.BIG}
              isFilled
              color={ButtonColor.GREEN}
              onClick={() => navigator.openProjectPage()}
              testId="done-button"
            />
          </Right>
        )}
      </div>
      <RelativeRow weights={[6, 6]}>
        <AddPersonToTransactionForm
          className={styles.block}
          projectId={projectId}
          hideAddToClientPortal
        />
        <CurrentTransactionPartiesForm projectId={projectId} />
      </RelativeRow>
    </>
  );
}
